import React from "react";
import "./PageWrapper.css";

const PageWrapper = ({ children }) => {
  return (
    <main id="main-content" className="page-wrapper" tabIndex={-1}>
      {children}
    </main>
  );
};

export default PageWrapper;
